import { Check } from "lucide-react";
import Link from "next/link";
import { ProPricingDetails } from "@/components/boardblend/pro-pricing-details";
import styles from "./home-pricing-section.module.css";

const freeFeatures = [
  "Create one active brainstorm",
  "Join unlimited brainstorms",
  "Up to 10 participants per brainstorm",
  "Personal AI agents",
  "Live transcription",
  "Document uploads",
  "Shared visual canvas",
  "Comments and collaboration",
];

export function HomePricingSection() {
  return (
    <section
      className={styles.section}
      id="pricing"
      aria-labelledby="home-pricing-heading"
    >
      <div className={styles.heading}>
        <p>Simple pricing</p>
        <h2 id="home-pricing-heading">
          One person upgrades.
          <br />
          Everyone participates for free.
        </h2>
        <span>
          Get Pro to create and save unlimited brainstorms.
          <br />
          Everyone you invite can join and contribute for free - no per-member
          pricing.
        </span>
      </div>

      <div className={styles.plans}>
        <article>
          <div className={styles.planHeading}>
            <p>Free</p>
            <strong>Free</strong>
            <span>Try it out</span>
          </div>
          <FeatureList features={freeFeatures} />
          <Link
            className={styles.secondaryAction}
            href="/sign-in?checkout=monthly"
          >
            Start free
          </Link>
        </article>

        <article className={styles.pro}>
          <ProPricingDetails />
          <div className={styles.actionGlow}>
            <Link
              className={styles.primaryAction}
              href="/sign-in?checkout=monthly"
            >
              Upgrade to Pro
            </Link>
          </div>
        </article>
      </div>
    </section>
  );
}

function FeatureList({ features }: { features: string[] }) {
  return (
    <ul className={styles.featureList}>
      {features.map((feature) => (
        <li key={feature}>
          <Check aria-hidden="true" />
          {feature}
        </li>
      ))}
    </ul>
  );
}
